/**
 * Formatting utilities
 * Moved from balanceConfig.ts and Header.tsx for proper module separation
 */

import { BALANCE_CONFIG } from '@/data/balance/balanceConfig';

/**
 * Format currency for display (e.g., 1500 → "1.5K", 2000000 → "2.0M")
 */
export function formatCurrency(amount: number): string {
  const safeAmount = amount ?? 0;

  if (safeAmount >= BALANCE_CONFIG.CURRENCY_FORMAT_THRESHOLD_M) {
    return `${(safeAmount / 1_000_000).toFixed(1)}M`;
  }
  if (safeAmount >= BALANCE_CONFIG.CURRENCY_FORMAT_THRESHOLD_K) {
    return `${(safeAmount / 1_000).toFixed(1)}K`;
  }
  return safeAmount.toFixed(0);
}

/**
 * Format time in seconds for display (e.g., 90 → "1m 30s", 5 → "5.0s")
 */
export function formatTime(seconds: number): string {
  if (seconds >= 60) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}m ${secs}s`;
  }
  return `${seconds.toFixed(1)}s`;
}

/**
 * Format a rate number for display (e.g., 1500 → "1.5K", 3.7 → "3.7")
 */
export function formatRate(n: number): string {
  if (n >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(1)}B`;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  if (n >= 10) return n.toFixed(0);
  if (n >= 1) return n.toFixed(1);
  if (n > 0) return n.toFixed(1);
  return '0';
}
